export class UserGroupInputDto {
  name: string;
  userIds: number[];
}
